export default {
  title: {
    en: '{count, plural, one {# Product} other {# Products}} / Month',
  },
  detailedTitle: {
    en: '{count} per shipment',
  },
}
